import {
    DEFAULT_LOCALE,
    scheduleStepDisplayLabel,
    type ScheduleStepLabelSource,
    type SupportedLocale,
} from "@patient-watch/i18n";

export type { ResolveScheduleStepLabelOptions, ScheduleStepLabelSource } from "@patient-watch/i18n";
export { deriveLabelFromTimingFields, resolveScheduleStepLabel, scheduleStepDisplayLabel } from "@patient-watch/i18n";

interface ScheduleLabelCopy {
    hasEntry: string;
}

const scheduleLabelCopy: Record<SupportedLocale, ScheduleLabelCopy> = {
    "en-GB": {
        hasEntry: "has entry",
    },
    "en-US": {
        hasEntry: "has entry",
    },
    "de-DE": {
        hasEntry: "hat Eintrag",
    },
    "da-DK": {
        hasEntry: "har indtastning",
    },
    "fr-FR": {
        hasEntry: "a une saisie",
    },
    "it-IT": {
        hasEntry: "ha un inserimento",
    },
    "es-ES": {
        hasEntry: "tiene un registro",
    },
};

function copyForLocale(locale: SupportedLocale = DEFAULT_LOCALE): ScheduleLabelCopy {
    return scheduleLabelCopy[locale] ?? scheduleLabelCopy[DEFAULT_LOCALE];
}

export interface ScheduleSlotLabelInput extends ScheduleStepLabelSource {
    label: string;
    schedule_index: number;
    interval: number;
    time_unit: string;
}

export function formatScheduleSlotLabel(
    slot: ScheduleSlotLabelInput,
    locale: SupportedLocale = DEFAULT_LOCALE
): string {
    return scheduleStepDisplayLabel(slot, locale);
}

export function formatScheduleSlotOptionLabel(
    slot: ScheduleSlotLabelInput & { status?: "current" | "empty" | "occupied" },
    locale: SupportedLocale = DEFAULT_LOCALE
): string {
    const base = formatScheduleSlotLabel(slot, locale);
    if (slot.status === "occupied") {
        return `${base} (${copyForLocale(locale).hasEntry})`;
    }
    return base;
}
